import './App.scss';
import {NavigationProvider} from "./context/NavigationContext/NavigationContext";
import {BrowserRouter} from "react-router-dom";
import {BlogContextProvider} from "./context/BlogContext/BlogContext";
import AppRouter from "./router/AppRouter";
function App() {
  return (
      <BlogContextProvider>
          <NavigationProvider>
                <BrowserRouter>
                    <AppRouter/>
                </BrowserRouter>
          </NavigationProvider>
      </BlogContextProvider>
  );
}
export default App;
